import { z } from "zod";
import { phoneSchema } from "./primitives.js";
export const passwordSchema = z
    .string()
    .min(8, "Use at least 8 characters")
    .max(128, "That is longer than 128 characters");
export const registerSchema = z.object({
    phone: phoneSchema,
    password: passwordSchema,
    name: z.string().trim().min(1).max(80).optional(),
});
export const loginSchema = z.object({
    phone: phoneSchema,
    password: z.string().min(1, "Enter your password"),
});
export const refreshSchema = z.object({
    refreshToken: z.string().min(1),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
//# sourceMappingURL=auth.js.map